import {
  // ---------------------
  GET_DESIGNATION_SUCCESS,
  ADD_DESIGINATION_SUCCESS,
  UPDATE_DESIGNATION_SUCCESS,
  DEL_DESIGNATION_SUCCESS,
  //----------------------
  GET_DEPARTMENT_SUCCESS,
  ADD_DEPARTMENT_SUCCESS,
  UPDATE_DEPARTMENT_SUCCESS,
  DELETE_DEPARTMENT_SUCCESS,
  // ---------------------
  GET_WORKPRIMISE_SUCCESS,
  ADD_WORKPRIMISE_SUCCESS,
  UPDATE_WORKPRIMISE_SUCCESS,
  DEL_WORKPRIMISE_SUCCESS,
  // ---------------------
  GET_OFFICELOCATION_SUCCESS,
  ADD_OFFICELOCATION_SUCCESS,
  UPDATE_OFFICELOCATION_SUCCESS,
  DEL_OFFICELOCATION_SUCCESS,
  DEL_OFFICELOCATION_ERROR,
  // ---------------------
  GET_REWARDS_SUCCESS,
  ADD_REWARDS_SUCCESS,
  UPDATE_REWARDS_SUCCESS,
  DEL_REWADRDS_SUCCESS,
  // ---------------------
  GET_ASSET_SUCCESS,
  ADD_ASSET_SUCCESS,
  UPDATE_ASSET_SUCCESS,
  DEL_ASSET_SUCCESS,
  DEL_ASSET_ITEMS_SUCCESS,
  //---employee types
  GET_EMPLOYEETYPE_LIST_SUCCESS,
  GET_EMPLOYEETYPES_BY_ID_SUCCESS,
  ADD_EMPLOYEETYPE_SUCCESS,
  UPDATE_EMPLOYEETYPE_SUCCESS,
  DELETE_EMPLOYEETYPE_SUCCESS,
  // -----------items.
  GET_ITEMS_SUCCESS,
  ADD_ITEM_SUCCESS,
  //-----leaves types
  GET_LEAVETYPES_SUCCESS,
  ADD_LEAVETYPES_SUCCESS,
  UPDATE_LEAVETYPES_SUCCESS,
  DELETE_LEAVETYPES_SUCCESS,
    //-----Duty types
    GET_DUTYYPES_SUCCESS,
    ADD_DUTYTYPES_SUCCESS,
    UPDATE_DUTYTYPES_SUCCESS,
    DELETE_DUTYTYPES_SUCCESS,
  //-------Company Policies
  GET_COMPANY_PLOICIES_SUCCESS,
  ADD_COMPANY_PLOICIES_SUCCESS,
  UPDATE_COMPANY_PLOICIES_SUCCESS,
  DELETE_COMPANY_PLOICIES_SUCCESS,
  //-----------Holiday Calendar
  GET_HOLIDAY_CALENDAR_SUCCESS,
  ADD_HOLIDAY_CALENDAR_SUCCESS,
  UPDATE_HOLIDAY_CALENDAR_SUCCESS,
  DELETE_HOLIDAY_CALENDAR_SUCCESS,
  // -------- Skill
  GET_SKILL_SUCCESS,  
  ADD_SKILL_SUCCESS,
  UPDATE_SKILL_SUCCESS,
  //------------Skill Category
  GET_SKILLCATEGORY_SUCCESS,
  ADD_SKILLCATEGORY_SUCCESS,
  UPDATE_SKILLCATEGORY_SUCCESS,
  DELETE_SKILLCATEGORY_SUCCESS,
  DELETE_SKILLCATEGORY_ERROR,

  //------------ADMIN Skills
  GET_ADMIN_SKILLS_SUCCESS,
  ADD_ADMIN_SKILLS_SUCCESS,
  UPDATE_ADMIN_SKILLS_SUCCESS,
  DELETE_ADMIN_SKILLS_SUCCESS,

  // --------- Certifations.
  GET_CERTIFICATIONS_SUCCESS,
  UPDATE_CERTIFICATION_SUCCESS,
  ADD_CERTIFICATION_SUCCESS,
  DELETE_CERTIFICATION_SUCCESS,

  //-----------Technologies
  GET_TECHNOLOGIES_SUCCESS,
  ADD_TECHNOLOGY_SUCCESS,
  UPDATE_TECHNOLOGY_SUCCESS,
  DELETE_TECHNOLOGY_SUCCESS,

  //-----------Review Rating
GET_REVIEWRATINGS_SUCCESS,
ADD_REVIEWRATINGS_SUCCESS,
UPDATE_REVIEWRATINGS_SUCCESS,
DELETE_REVIEWRATINGS_SUCCESS,

  //-----------Review Rating
  GET_ROLE_SUCCESS,
  ADD_ROLE_SECCESS,
  UPDATE_ROLE_SUCCESS,
  DELETE_ROLE_SUCCESS,

//................Behavioral attribute
GET_BEHAVIORALATTRIBUTES_SUCCESS,
ADD_BEHAVIORALATTRIBUTES_SUCCESS,
UPDATE_BEHAVIORALATTRIBUTES_SUCCESS,
DELETE_BEHAVIORALATTRIBUTES_SUCCESS,


//------------------Potential
GET_POTENTIAL_SUCCESS,
ADD_POTENTIAL_SUCCESS,
UPDATE_POTENTIAL_SUCCESS,
DELETE_POTENTIAL_SUCCESS,

//--------primaryGoals---------------
  GET_GOALS_SUCCESS,
  ADD_PRIMARY_GOALS_SUCCESS,
  UPDATE_PRIMARY_GOALS_SUCCESS,
  DELETE_PRIMARY_GOALS_SUCCESS,
  GET_GOALS_BY_DESIGNATION_SUCCESS, 

//-------- GET_APPRAISAL_QUESTIONS,
//GET_ALLAPPRAISAL_QUESTIONS_SUCCESS,
  ADD_APPRAISAL_QUESTIONS_SUCESS,
  UPDATE_APPRAISAL_QUESTIONS_SUCESS,
  DELETE_APPRAISAL_QUESTIONS_SUCESS,

  GET_CALENDARYEAR_SUCCESS,
  ADD_CALENDARYEAR_SUCCESS,
  UPDATE_CALENDARYEAR_SUCCESS,
  DELETE_CALENDARYEAR_SUCCESS,

  GET_RECANDHOLIDAY_CALENDAR_SUCCESS,
  ADD_RECANDHOLIDAY_CALENDAR_SUCCESS,
  UPDATE_RECANDHOLIDAY_CALENDAR_SUCCESS,
  DELETE_RECANDHOLIDAY_CALENDAR_SUCCESS,

  GET_CONFIGUREMAIL_SUCCESS,
  CREATE_CONFIGUREMAIL_SUCCESS,
  GET_REQUESTTYPE_SUCCESS

} from "../../actions/actionType";

const initialState = {
  assetSelected: null,
  departments: [],
  designations: [],
  workPrimisesList: [],
  rewards: [],
  officeLocation: [],
  assetList: [],
  employeetypes: [],
  itemList: [],
  leavetypes: [],
  companypolicies: [],
  holidayCalendar: [],
  skillList: [],
  certifications: [],
  skillcategories:[],
  technologies:[],
  reviewrating:[],
  attributes:[],
  potential:[],
  role:[],
  primarygoals: [],
  goals:[],
  appraisalQuestionList :[],
  skillcategoryError:true,
  calendaryear:[],
  recandholidayList: [],
  configuremailList:[],
  requestTypeList :[]
  // user list.
};

export default function (state = initialState, action) {
  switch (action.type) {
    // ----------------- Office Location.
    case GET_OFFICELOCATION_SUCCESS:
      return {
        ...state,
        officeLocation: action.payload,
      };
    case ADD_OFFICELOCATION_SUCCESS:
      return {
        ...state,
        officeLocation: [...state.officeLocation, action.payload],
      };
    case UPDATE_OFFICELOCATION_SUCCESS:
      return {
        ...state,
        officeLocation: state.officeLocation.map((officeLocation) =>
          officeLocation.officeLocationId === action.payload.officeLocationId
            ? action.payload
            : officeLocation
        ),
      };
    case DEL_OFFICELOCATION_SUCCESS:
      return {
        ...state,
        officeLocation: state.officeLocation.filter(
          (el) => el.officeLocationId !== action.payload
        ),
      };
      case DEL_OFFICELOCATION_ERROR:
        return {
          ...state,
          officeLocation: false,
        };
    // ----------------- Designation.
    case GET_DESIGNATION_SUCCESS:
      return {
        ...state,
        designations: action.payload,
      };
    case ADD_DESIGINATION_SUCCESS:
      return {
        ...state,
        designations: [...state.designations, action.payload],
      };
    case UPDATE_DESIGNATION_SUCCESS:
      return {
        ...state,
        designations: state.designations.map((el) =>
          el.designationId === action.payload.designationId
            ? action.payload
            : el
        ),
      };
    case DEL_DESIGNATION_SUCCESS:
      return {
        ...state,
        designations: state.designations.filter(
          (el) => el.designationId !== action.payload
        ),
      };
    //--------------------Department
    case GET_DEPARTMENT_SUCCESS:
      return {
        ...state,
        departments: action.payload,
      };
    case ADD_DEPARTMENT_SUCCESS:
      return {
        ...state,
        departments: [...state.departments, action.payload],
      };
    case UPDATE_DEPARTMENT_SUCCESS:

      return {
        ...state,
        departments: state.departments.map((el) =>
          el.departmentId === action.payload.departmentId ? action.payload : el
        ),
      };
    case DELETE_DEPARTMENT_SUCCESS:
      return {
        ...state,
        departments: state.departments.filter(
          (el) => el.departmentId !== action.payload
        ),
      };

    // ----------------- Work Primise.
    case GET_WORKPRIMISE_SUCCESS:
      return {
        ...state,
        workPrimisesList: action.payload,
      };
    case ADD_WORKPRIMISE_SUCCESS:
      return {
        ...state,
        workPrimisesList: [...state.workPrimisesList, action.payload],
      };
    case UPDATE_WORKPRIMISE_SUCCESS:
      return {
        ...state,
        workPrimisesList: state.workPrimisesList.map((el) =>
          el.workingPremiseId === action.payload.workingPremiseId
            ? action.payload
            : el
        ),
      };
    case DEL_WORKPRIMISE_SUCCESS:
      return {
        ...state,
        workPrimisesList: state.workPrimisesList.filter(
          (el) => el.workingPremiseId !== action.payload
        ),
      };

    // ------------------------Rewards.
    case GET_REWARDS_SUCCESS:
      return {
        ...state,
        rewards: action.payload,
      };
    case ADD_REWARDS_SUCCESS:
      return {
        ...state,
        rewards: [...state.rewards, action.payload],
      };
    case UPDATE_REWARDS_SUCCESS:
      return {
        ...state,
        rewards: state.rewards.map((el) =>
          el.rewardId === action.payload.rewardId ? action.payload : el
        ),
      };
    case DEL_REWADRDS_SUCCESS:
      return {
        ...state,
        rewards: state.rewards.filter((el) => el.rewardId !== action.payload),
      };

    //----Employee Types---//
    case GET_EMPLOYEETYPE_LIST_SUCCESS:
      return {
        ...state,
        employeetypes: action.payload,
      };
    case GET_EMPLOYEETYPES_BY_ID_SUCCESS:
      return {
        ...state,
        employeetypes: action.payload,
      };
    case ADD_EMPLOYEETYPE_SUCCESS:
      return {
        ...state,
        employeetypes: [...state.employeetypes, action.payload],
      };
    case UPDATE_EMPLOYEETYPE_SUCCESS:
      return {
        ...state,
        employeetypes: state.employeetypes.map((el, i) =>
          el.employeeTypeId === action.payload.employeeTypeId
            ? action.payload
            : el
        ),
      };
    case DELETE_EMPLOYEETYPE_SUCCESS:
      return {
        ...state,
        employeetypes: state.employeetypes.filter(
          (el) => el.employeeTypeId !== action.payload
        ),
      };

    // ---------------------------Items.
    case GET_ITEMS_SUCCESS:
      return {
        ...state,
        itemList: action.payload,
      };
    case ADD_ITEM_SUCCESS:
      return {
        ...state,
        itemList: [...state.itemList, action.payload],
      };
    // ----------------- Asset.
    case GET_ASSET_SUCCESS:
      return {
        ...state,
        assetList: action.payload,
      };
    case ADD_ASSET_SUCCESS:
      return {
        ...state,
        assetList: [...state.assetList, action.payload],
      };
    case UPDATE_ASSET_SUCCESS:
      return {
        ...state,
        assetList: state.assetList.map((el) =>
          el.itemNo === action.payload.itemNo ? action.payload : el
        ),
      };
    case DEL_ASSET_SUCCESS:
      return {
        ...state,
        assetList: state.assetList.map((el) =>
          el.itemNo === action.payload.itemNo ? action.payload : el
        ),
        // assetList: state.assetList.filter((el) => el.itemNo !== action.payload),
      };
      case DEL_ASSET_ITEMS_SUCCESS:
      return {
        ...state,
        assetList: state.assetList.filter((el) => el.itemNo !== action.payload),
      };
    //----Leave Types---//
    case GET_LEAVETYPES_SUCCESS:
      return {
        ...state,
        leavetypes: action.payload,
      };
    case ADD_LEAVETYPES_SUCCESS:
      return {
        ...state,
        leavetypes: [...state.leavetypes, action.payload],
      };
    case UPDATE_LEAVETYPES_SUCCESS:
      return {
        ...state,
        leavetypes: state.leavetypes.map((el, i) =>
          el.leaveTypeId === action.payload.leaveId ? action.payload : el
        ),
      };
    case DELETE_LEAVETYPES_SUCCESS:
      return {
        ...state,
        leavetypes: state.leavetypes.filter(
          (el) => el.leaveId !== action.payload
        ),
      };

      //----Duty Types---//
    case GET_DUTYYPES_SUCCESS:
      return {
        ...state,
        leavetypes: action.payload,
      };
    case ADD_DUTYTYPES_SUCCESS:
      return {
        ...state,
        leavetypes: [...state.leavetypes, action.payload],
      };
    case UPDATE_DUTYTYPES_SUCCESS:
      return {
        ...state,
        leavetypes: state.leavetypes.map((el, i) =>
          el.leaveTypeId === action.payload.leaveId ? action.payload : el
        ),
      };
    case DELETE_DUTYTYPES_SUCCESS:
      return {
        ...state,
        leavetypes: state.leavetypes.filter(
          (el) => el.leaveId !== action.payload
        ),
      };

    //----Company Policies---//
    case GET_COMPANY_PLOICIES_SUCCESS:
      return {
        ...state,
        companypolicies: action.payload,
      };
    case ADD_COMPANY_PLOICIES_SUCCESS:
      return {
        ...state,
        companypolicies: [...state.companypolicies, action.payload],
      };
    case UPDATE_COMPANY_PLOICIES_SUCCESS:
      return {
        ...state,
        companypolicies: state.companypolicies.map((el, i) =>
          el.companyPolicyId === action.payload.companyPolicyId
            ? action.payload
            : el
        ),
      };
    case DELETE_COMPANY_PLOICIES_SUCCESS:
      return {
        ...state,
        companypolicies: state.companypolicies.filter(
          (el) => el.companyPolicyId !== action.payload
        ),
      };

    //----Holiday Calendar---//
    case GET_HOLIDAY_CALENDAR_SUCCESS:
      return {
        ...state,
        holidayCalendar: action.payload,
      };
    case ADD_HOLIDAY_CALENDAR_SUCCESS:
      return {
        ...state,
        holidayCalendar: [...state.holidayCalendar, action.payload],
      };
    case UPDATE_HOLIDAY_CALENDAR_SUCCESS:
      return {
        ...state,
        holidayCalendar: state.holidayCalendar.map((el, i) =>
          el.holidayCalendarId === action.payload.holidayCalendarId
            ? action.payload
            : el
        ),
      };
    case DELETE_HOLIDAY_CALENDAR_SUCCESS:
      return {
        ...state,
        holidayCalendar: state.holidayCalendar.filter(
          (el) => el.holidayCalendarId !== action.payload
        ),
      };
    case GET_SKILL_SUCCESS:
      return {
        ...state,
        skillList: action.payload,
      };   
      //---------------------------Skill Category--------------------------
   case GET_SKILLCATEGORY_SUCCESS:
    return {
      ...state,
      skillcategories: action.payload,
    };
  case ADD_SKILLCATEGORY_SUCCESS:
    return {
      ...state,
      skillcategories: [...state.skillcategories, action.payload],
    };
  case UPDATE_SKILLCATEGORY_SUCCESS:

    return {
      ...state,
      skillcategories: state.skillcategories.map((el) =>
        el.skillCategoryId === action.payload.skillCategoryId ? action.payload : el
      ),
    };
  case DELETE_SKILLCATEGORY_SUCCESS:
    return {
      ...state,
      skillcategories: state.skillcategories.filter(
        (el) => el.skillCategoryId !== action.payload
      ),
    };
    case DELETE_SKILLCATEGORY_ERROR:
      return {
        ...state,
        skillcategoryError: false,
      };
      //------------admin skill
  case GET_ADMIN_SKILLS_SUCCESS:
    return {
      ...state,
      skillList: action.payload,
    };
  case ADD_ADMIN_SKILLS_SUCCESS:
    return {
      ...state,
      skillList: [...state.skillList, action.payload],
    };
    case UPDATE_ADMIN_SKILLS_SUCCESS:
      return {
        ...state,
        skillList: state.skillList.map((el) =>
          el.skillId === action.payload.skillId
            ? action.payload
            : el
        ),
      };
    case DELETE_ADMIN_SKILLS_SUCCESS:
      return {
        ...state,
        skillList: state.skillList.filter(
          (el) => el.skillId !== action.payload
        ),
      };
   // ---------------------------Certification-------------------------------
   case GET_CERTIFICATIONS_SUCCESS:
    return {
      ...state,
      certifications: action.payload,
    };

    case ADD_CERTIFICATION_SUCCESS:
    return {
      ...state,
      certifications: [...state.certifications, action.payload],
    };
  case UPDATE_CERTIFICATION_SUCCESS:

    return {
      ...state,
      certifications: state.certifications.map((el) =>
        el.certificationId === action.payload.certificationId ? action.payload : el
      ),
    };
  case DELETE_CERTIFICATION_SUCCESS:
    return {
      ...state,
      certifications: state.certifications.filter(
        (el) => el.certificationId !== action.payload
      ),
    };

       // ---------------------------Technologies-------------------------------
   case GET_TECHNOLOGIES_SUCCESS:
    return {
      ...state,
      technologies: action.payload,
    };

    case ADD_TECHNOLOGY_SUCCESS:
    return {
      ...state,
      technologies: [...state.technologies, action.payload],
    };
  case UPDATE_TECHNOLOGY_SUCCESS:

    return {
      ...state,
      technologies: state.technologies.map((el) =>
        el.technologyId === action.payload.technologyId ? action.payload : el
      ),
    };
  case DELETE_TECHNOLOGY_SUCCESS:
    return {
      ...state,
      technologies: state.technologies.filter(
        (el) => el.technologyId !== action.payload
      ),
    };
//----Review Rating---//
case GET_REVIEWRATINGS_SUCCESS:
  return {
    ...state,
    reviewrating: action.payload,
  };
case ADD_REVIEWRATINGS_SUCCESS:
  return {
    ...state,
    reviewrating: [...state.reviewrating, action.payload],
  };
  case UPDATE_REVIEWRATINGS_SUCCESS:
    
  return {
    ...state,
    reviewrating: state.reviewrating.map((el, i) =>
      el.ratingId === action.payload.ratingId
        ? action.payload
        : el
    ),
  };
case DELETE_REVIEWRATINGS_SUCCESS:
  return {
    ...state,
    reviewrating: state.reviewrating.filter(
      (el) => el.ratingId !== action.payload
    ),
  };

//----Role---//
case GET_ROLE_SUCCESS:
  return {
    ...state,
    role: action.payload,
  };
case ADD_ROLE_SECCESS:
  return {
    ...state,
    role: [...state.role, action.payload],
  };
  case UPDATE_ROLE_SUCCESS:
    
  return {
    ...state,
    role: state.role.map((el, i) =>
      el.roleId === action.payload.roleId
        ? action.payload
        : el
    ),
  };
case DELETE_ROLE_SUCCESS:
  return {
    ...state,
    role: state.role.filter(
      (el) => el.roleId !== action.payload
    ),
  };
 //----Behavioral attributes---//
 case GET_BEHAVIORALATTRIBUTES_SUCCESS:
  return {
    ...state,
    attributes: action.payload,
  };
case ADD_BEHAVIORALATTRIBUTES_SUCCESS:
  return {
    ...state,
    attributes: [...state.attributes, action.payload],
  };
case UPDATE_BEHAVIORALATTRIBUTES_SUCCESS:

  return {
    ...state,
    attributes: state.attributes.map((el, i) =>
      el.attributeId === action.payload.attributeId
        ? action.payload
        : el
    ),
  };
case DELETE_BEHAVIORALATTRIBUTES_SUCCESS:
  return {
    ...state,
    attributes: state.attributes.filter(
      (el) => el.attributeId !== action.payload
    ),
  };


 //----Potential---//
 case GET_POTENTIAL_SUCCESS:
  return {
    ...state,
    potential: action.payload,
  };
case ADD_POTENTIAL_SUCCESS:
  return {
    ...state,
    potential: [...state.potential, action.payload],
  };
case UPDATE_POTENTIAL_SUCCESS:

  return {
    ...state,
    potential: state.potential.map((el, i) =>
      el.potentialId === action.payload.potentialId
        ? action.payload
        : el
    ),
  };
case DELETE_POTENTIAL_SUCCESS:
  return {
    ...state,
    potential: state.potential.filter(
      (el) => el.potentialId !== action.payload
    ),
  };

//----Calendar Year---//
case GET_CALENDARYEAR_SUCCESS:
  return {
    ...state,
    calendaryear: action.payload,
  };
case ADD_CALENDARYEAR_SUCCESS:
  return {
    ...state,
    calendaryear: [...state.reviewrating, action.payload],
  };
  case UPDATE_CALENDARYEAR_SUCCESS:
    
  return {
    ...state,
    calendaryear: state.calendaryear.map((el, i) =>
      el.ratingId === action.payload.ratingId
        ? action.payload
        : el
    ),
  };
case DELETE_CALENDARYEAR_SUCCESS:
  return {
    ...state,
    calendaryear: state.calendaryear.filter(
      (el) => el.ratingId !== action.payload
    ),
  };


 //----Recursive and Holiday Calendar---//
 case GET_RECANDHOLIDAY_CALENDAR_SUCCESS:
  return {
    ...state,
    recandholidayList: action.payload,
  };


    //----------------------------------
    case GET_GOALS_SUCCESS:
      {
        return{
          ...state,
          primarygoals: action.payload,
        }
      };
      case ADD_PRIMARY_GOALS_SUCCESS:
    return {
      ...state,
      goals: [...state.goals, action.payload],
    };

    case UPDATE_PRIMARY_GOALS_SUCCESS:

    return {
      ...state,
      goals: state.goals.map((el) =>
        el.goalId === action.payload.goalId ? action.payload : el
      ),
    };
  case DELETE_PRIMARY_GOALS_SUCCESS:
    return {
      ...state,
      goals: state.goals.filter(
        (el) => el.goalId !== action.payload.goalId
      ),
    };
    case GET_GOALS_BY_DESIGNATION_SUCCESS:
      return {
          ...state,
          goals: action.payload,
          attributes :action.payload,
      };
      case GET_CONFIGUREMAIL_SUCCESS:
        return {
          ...state,
          configuremailList: action.payload,
        };
      case CREATE_CONFIGUREMAIL_SUCCESS:
        return {
          ...state,
          configuremailList: [...state.configuremailList, action.payload],
        };
        case GET_REQUESTTYPE_SUCCESS:
        return {
          ...state,
          requestTypeList: action.payload,
        };
    //case GET_ALLAPPRAISAL_QUESTIONS_SUCCESS:
      //{ console.log(action.payload,GET_ALLAPPRAISAL_QUESTIONS_SUCCESS);
       // return{
         // ...state,
          
         // appraisalquestions: action.payload,
        //}
      //};
    
    default:
      return state;
  } 

    
}
